import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
//Axios
import clienteAxios from '../../../../../config/axios';
//Redux
import { useDispatch } from 'react-redux';
import { updateOperatorAction } from '../../../../../actions/audiencesActions';
import { ErrorMessage } from '../../../../extras/toastMessages';
import ButtonSpinner from '../../../../layout/ButtonSpinner';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
//Función principal
const OperatorEditForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los refs
    const refOperator = useRef();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo los datos
    const initialData = {
        operador: audience && audience.operador ? audience.operador.id : ''
    }
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [operators, setOperators] = useState([]);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los parámetros
        loadParameters();
        //Pongo el foco en el primer campo
        refOperator.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            operadorId: parseInt(values.operador)
        }
        //Llamo al dispatch
        dispatch( updateOperatorAction(audience, data, handleClose) );
    }
    //Función que maneja los parámetros
    const loadParameters = async () => {
        try{
            //Cargo la espera
            setLoading(true);
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=perfil.id:2,nivel.id:3&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
            //Oculto la espera
            setLoading(false);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Esquema de validación
    const validationSchema = yup.object({
        operador: yup.number().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Editar Operador</strong> <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione el operador a asignar
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        id="operador"
                                        className="form-control"  
                                        name="operador" 
                                        value={ values.operador }
                                        onChange={handleChange}
                                        isInvalid={!!errors.operador}
                                        disabled={ loading }
                                        ref={refOperator}
                                    >
                                        <option value="">Seleccion Operador...</option>
                                        {
                                            operators.map(operator => (
                                                <option value={operator.id} key={`oefo${operator.id}`}>
                                                    { operator.apellido + ', ' + operator.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.operador }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default OperatorEditForm;